import { ApplicationConfig, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { loadAppConfig } from './core/config/app-config.loader';
import { loadModules } from './core/config/modules.loader';
import { redirectCheckoutReturnIfNeeded } from './core/config/checkout-return.initializer';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { APP_LOGO_URL, APP_NAME } from './core/constants/app.constants';
import { ADMIN_SHELL_BRANDING } from '@ecommerce/admin/tokens/admin-shell-branding.token';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ADMIN_SHELL_BRANDING,
      useValue: { appName: APP_NAME, logoUrl: APP_LOGO_URL }
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor])),
    provideAppInitializer(loadAppConfig),
    provideAppInitializer(loadModules),
    provideAppInitializer(redirectCheckoutReturnIfNeeded)
  ]
};
